{
  "selectAsField": "Вибрати \"{value}\" як {fieldName}",
  "typeToSearchField": "Введіть для пошуку {fieldName}",
  "licenseFieldLabel": "Вибрати номерний знак (напр. 215BG2)",
  "licenseFieldName": "Номерний знак",
  "licensePlaceholder": "Пошук за номерним знаком",
  "dotFieldLabel": "Вибрати номер DOT",
  "dotFieldName": "Номер DOT",
  "dotPlaceholder": "Пошук за номером DOT",
  "chooseOneOption": "Виберіть один із варіантів нижче"
}
